import { Box, Card, Fade, Menu, MenuItem, Typography } from "@mui/material";
import { DownArrow, ErrorIcon, MinusIcon, PlusIcon } from "../../../../../../common/icons/Icons";
import { Home } from '@mui/icons-material';
import { createRef, useState } from "react";
import { validated } from "../../../../../../common/inputs/ValidatedInputs";
import PropTypes from 'prop-types';

const AccommodationCard = ({ reservation, editing, availableRooms = [], onRoomSelect, onOccupancyChange, cardStyle }) => {
    //const room = rooms.find(room => room.id === reservation.roomId);
    const [anchorEl, setAnchorEl] = useState(null);

    const roomNameRef = createRef();

    const selectedRoom = availableRooms.find(room => room.id === reservation.roomId);

    const handleClose = (roomId) => {
        setAnchorEl(null);
        roomId && onRoomSelect(roomId);
    }

    return <>
        <Card sx={{ ...cardStyle, justifyContent: 'center' }}>
            <Home sx={{ margin: '10px' }} />
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', height: '82px' }}>
                <DownArrow size='small' hidden />
                <Typography ref={roomNameRef} variant='h6' sx={{ width: '150px', textAling: 'left' }}>{selectedRoom.name}</Typography>
                <DownArrow data-testid='selectRoomButton' size='small' onClick={() => setAnchorEl(roomNameRef.current)} hidden={!editing} title='Select room' />
            </Box>
            <ValidatedOccupancyEditor
                id='adults'
                value={reservation.adults}
                onChange={onOccupancyChange}
                editing={editing}
                min={1}
                max={selectedRoom.maxOccupancy}
                getErrorMessage={reason => {
                    switch (reason) {
                        case "min":
                            return "Number of guests must be higher than 0";
                        case "max":
                            return "Room max occupancy exceeded";
                        default:
                            return reason;
                    }
                }}
            />
        </Card>
        {
            editing && <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={handleClose}
                TransitionComponent={Fade}
                sx={{
                    '& .MuiMenu-paper': {
                        minWidth: '150px',
                    }
                }}
            >
                {availableRooms.map(room => <MenuItem key={`room_${room.id}`} selected={room.id === selectedRoom.id} onClick={() => handleClose(room.id)}>{room.name}</MenuItem>)}
            </Menu>
        }
    </>
}

export const OccupancyEditor = ({ value, editing, min = 0, max, onChange, valid = true, errorMessage }) => {
    const handleAddGuests = () => onChange(value + 1);
    const handleRemoveGuests = () => onChange(value - 1);

    return <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
        {!valid && <Box sx={{ width: '24px' }} />}
        <MinusIcon data-testid='minusOccupancyButton' disabled={value <= min} childProps={{ sx: { fontSize: '1rem', padding: '4px' } }} hidden={!editing} onClick={handleRemoveGuests} size='small' />
        <Typography sx={{ minWidth: '65px', color: !valid ? 'error.main' : 'text' }}>{`${value} guest${value < 2 ? '' : 's'}`}</Typography>
        <PlusIcon data-testid='plusOccupancyButton' disabled={max && value >= max} childProps={{ sx: { fontSize: '1rem', padding: '4px' } }} hidden={!editing} onClick={handleAddGuests} size='small' />
        {!valid && <ErrorIcon title={errorMessage} />}
    </Box>;
}

OccupancyEditor.propTypes = {
    value: PropTypes.number.isRequired,
    editing: PropTypes.bool,
    min: PropTypes.number,
    max: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    validationResult: PropTypes.shape({
        valid: PropTypes.bool.isRequired,
        message: PropTypes.string,
    }),
};

AccommodationCard.propTypes = {
    reservation: PropTypes.object.isRequired,
    editing: PropTypes.bool,
    onRoomSelect: PropTypes.func,
    onOccupancyChange: PropTypes.func,
    cardStyle: PropTypes.object,
}

const ValidatedOccupancyEditor = validated(OccupancyEditor);

export default AccommodationCard;